import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { environment as ENV } from '@environment/environment';

import { FeatureFlagItem, IFeatureFlagStatus } from '@interfaces/i-feature-flag.interface';
import { SoaApi } from '@interfaces/i-cancel-subscription';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagV3Service {

  private API = `${ENV.soaApiBaseUrl}/featureflag`;
  private featureStatus: IFeatureFlagStatus[] = [];

  constructor(private http: HttpClient) {}

  get areThereFeatures(): boolean {
    return this.featureStatus.length > 0;
  }

  public getAllFeaturesStatus(): Observable<IFeatureFlagStatus[]> {
    return this.http.get<SoaApi<FeatureFlagItem[]>>(this.API)
    .pipe(
      map(response => {
        const flags = response.value || [];
        return flags.map((flag: FeatureFlagItem) => ({
          feature: flag.key,
          status: flag.value
        }));
      }),
      tap(flags => this.featureStatus = flags)
    );
  }

  public getFeatureStatus(key: string): Observable<boolean> {
    return this.http
      .get<SoaApi<FeatureFlagItem>>(`${this.API}/${key}`)
      .pipe(map(response => response.value?.value || false));
  }

  public checkFeatureOn(featureName: string): boolean {
    let feature: IFeatureFlagStatus;
    feature = this.featureStatus.find((item: IFeatureFlagStatus) => {
      return item.feature === featureName;
    });
    return feature && feature.status === true;
  }

  public fillFeaturesFlags(result: IFeatureFlagStatus[]): void {
    this.featureStatus = result;
  }

}
